export type HasToString = {
	toString(): string;
};

export type TableCellValueType = HasToString;
export type TableEntryStruct = Record<string, TableCellValueType> & {
	extra?: any;
};

export type TableObjectKey = keyof TableEntryStruct;

export const SortableCycleTableColumn = {
	last_update: 'last_update',
	start_date: 'start_date',
	cycle_creator: 'cycle_creator',
} as const;
export type SortableCycleTableColumn = (typeof SortableCycleTableColumn)[keyof typeof SortableCycleTableColumn];
